/*
  Automation page, "History" tab: the last rule runs from
  GET /api/automation/history, with a real error state.
  Merged FIRST into TRANSLATION_MAPS in ./index.js. Keys are the English source.
*/

const ru = {
  "The last {count} rule runs, newest first.": "Последние {count} срабатываний правил, новые сверху.",
  "Refresh history": "Обновить историю",
  "Could not load the execution history.": "Не удалось загрузить историю выполнения.",
  "This is a loading error, not an empty history. Try again in a minute.": "Это ошибка загрузки, а не пустая история. Попробуйте ещё раз через минуту.",
  "Try loading again": "Загрузить ещё раз",
  "Loading the execution history…": "Загружаем историю выполнения…",
  "Run time": "Время",
  "Rule name": "Правило",
  "Campaign name": "Кампания",
  "Rule type": "Тип правила",
  "What the rule did": "Что сделано",
  "Execution history": "История выполнения",
  "Execution history is empty": "История выполнения пуста",
  "Records of automatic rule executions will appear here": "Здесь появятся записи о срабатывании правил",
};

const es = {
  "The last {count} rule runs, newest first.": "Las últimas {count} ejecuciones de reglas, las más recientes primero.",
  "Refresh history": "Actualizar historial",
  "Could not load the execution history.": "No se pudo cargar el historial de ejecución.",
  "This is a loading error, not an empty history. Try again in a minute.": "Es un error de carga, no un historial vacío. Inténtalo de nuevo en un minuto.",
  "Try loading again": "Volver a cargar",
  "Loading the execution history…": "Cargando el historial de ejecución…",
  "Run time": "Hora",
  "Rule name": "Regla",
  "Campaign name": "Campaña",
  "Rule type": "Tipo de regla",
  "What the rule did": "Qué hizo la regla",
  "Execution history": "Historial de ejecución",
  "Execution history is empty": "El historial de ejecución está vacío",
  "Records of automatic rule executions will appear here": "Aquí aparecerán los registros de las ejecuciones de reglas",
};

const pt = {
  "The last {count} rule runs, newest first.": "As últimas {count} execuções de regras, as mais recentes primeiro.",
  "Refresh history": "Atualizar histórico",
  "Could not load the execution history.": "Não foi possível carregar o histórico de execução.",
  "This is a loading error, not an empty history. Try again in a minute.": "É um erro de carregamento, não um histórico vazio. Tente de novo em um minuto.",
  "Try loading again": "Carregar de novo",
  "Loading the execution history…": "Carregando o histórico de execução…",
  "Run time": "Hora",
  "Rule name": "Regra",
  "Campaign name": "Campanha",
  "Rule type": "Tipo de regra",
  "What the rule did": "O que a regra fez",
  "Execution history": "Histórico de execução",
  "Execution history is empty": "O histórico de execução está vazio",
  "Records of automatic rule executions will appear here": "Aqui vão aparecer os registros das execuções de regras",
};

const de = {
  "The last {count} rule runs, newest first.": "Die letzten {count} Regelausführungen, neueste zuerst.",
  "Refresh history": "Verlauf aktualisieren",
  "Could not load the execution history.": "Der Ausführungsverlauf konnte nicht geladen werden.",
  "This is a loading error, not an empty history. Try again in a minute.": "Das ist ein Ladefehler, kein leerer Verlauf. Versuch es in einer Minute erneut.",
  "Try loading again": "Erneut laden",
  "Loading the execution history…": "Ausführungsverlauf wird geladen…",
  "Run time": "Zeit",
  "Rule name": "Regel",
  "Campaign name": "Kampagne",
  "Rule type": "Regeltyp",
  "What the rule did": "Was die Regel getan hat",
  "Execution history": "Ausführungsverlauf",
  "Execution history is empty": "Der Ausführungsverlauf ist leer",
  "Records of automatic rule executions will appear here": "Hier erscheinen die Einträge zu Regelausführungen",
};

const fr = {
  "The last {count} rule runs, newest first.": "Les {count} dernières exécutions de règles, les plus récentes en premier.",
  "Refresh history": "Actualiser l'historique",
  "Could not load the execution history.": "Impossible de charger l'historique d'exécution.",
  "This is a loading error, not an empty history. Try again in a minute.": "C'est une erreur de chargement, pas un historique vide. Réessayez dans une minute.",
  "Try loading again": "Recharger",
  "Loading the execution history…": "Chargement de l'historique d'exécution…",
  "Run time": "Heure",
  "Rule name": "Règle",
  "Campaign name": "Campagne",
  "Rule type": "Type de règle",
  "What the rule did": "Ce qu'a fait la règle",
  "Execution history": "Historique d'exécution",
  "Execution history is empty": "L'historique d'exécution est vide",
  "Records of automatic rule executions will appear here": "Les exécutions des règles apparaîtront ici",
};

const it = {
  "The last {count} rule runs, newest first.": "Le ultime {count} esecuzioni delle regole, dalla più recente.",
  "Refresh history": "Aggiorna cronologia",
  "Could not load the execution history.": "Impossibile caricare la cronologia delle esecuzioni.",
  "This is a loading error, not an empty history. Try again in a minute.": "È un errore di caricamento, non una cronologia vuota. Riprova tra un minuto.",
  "Try loading again": "Ricarica",
  "Loading the execution history…": "Caricamento della cronologia…",
  "Run time": "Ora",
  "Rule name": "Regola",
  "Campaign name": "Campagna",
  "Rule type": "Tipo di regola",
  "What the rule did": "Cosa ha fatto la regola",
  "Execution history": "Cronologia esecuzioni",
  "Execution history is empty": "La cronologia delle esecuzioni è vuota",
  "Records of automatic rule executions will appear here": "Qui compariranno le esecuzioni delle regole",
};

const pl = {
  "The last {count} rule runs, newest first.": "Ostatnie {count} uruchomień reguł, najnowsze na górze.",
  "Refresh history": "Odśwież historię",
  "Could not load the execution history.": "Nie udało się wczytać historii uruchomień.",
  "This is a loading error, not an empty history. Try again in a minute.": "To błąd wczytywania, a nie pusta historia. Spróbuj ponownie za minutę.",
  "Try loading again": "Wczytaj ponownie",
  "Loading the execution history…": "Wczytywanie historii uruchomień…",
  "Run time": "Czas",
  "Rule name": "Reguła",
  "Campaign name": "Kampania",
  "Rule type": "Typ reguły",
  "What the rule did": "Co zrobiła reguła",
  "Execution history": "Historia uruchomień",
  "Execution history is empty": "Historia uruchomień jest pusta",
  "Records of automatic rule executions will appear here": "Tutaj pojawią się wpisy o uruchomieniach reguł",
};

const tr = {
  "The last {count} rule runs, newest first.": "Son {count} kural çalıştırması, en yenisi üstte.",
  "Refresh history": "Geçmişi yenile",
  "Could not load the execution history.": "Çalıştırma geçmişi yüklenemedi.",
  "This is a loading error, not an empty history. Try again in a minute.": "Bu bir yükleme hatasıdır, boş bir geçmiş değil. Bir dakika sonra tekrar deneyin.",
  "Try loading again": "Tekrar yükle",
  "Loading the execution history…": "Çalıştırma geçmişi yükleniyor…",
  "Run time": "Zaman",
  "Rule name": "Kural",
  "Campaign name": "Kampanya",
  "Rule type": "Kural türü",
  "What the rule did": "Kuralın yaptığı",
  "Execution history": "Çalıştırma geçmişi",
  "Execution history is empty": "Çalıştırma geçmişi boş",
  "Records of automatic rule executions will appear here": "Kural çalıştırma kayıtları burada görünecek",
};

const uk = {
  "The last {count} rule runs, newest first.": "Останні {count} спрацювань правил, нові зверху.",
  "Refresh history": "Оновити історію",
  "Could not load the execution history.": "Не вдалося завантажити історію виконання.",
  "This is a loading error, not an empty history. Try again in a minute.": "Це помилка завантаження, а не порожня історія. Спробуйте ще раз за хвилину.",
  "Try loading again": "Завантажити ще раз",
  "Loading the execution history…": "Завантажуємо історію виконання…",
  "Run time": "Час",
  "Rule name": "Правило",
  "Campaign name": "Кампанія",
  "Rule type": "Тип правила",
  "What the rule did": "Що зроблено",
  "Execution history": "Історія виконання",
  "Execution history is empty": "Історія виконання порожня",
  "Records of automatic rule executions will appear here": "Тут з’являться записи про спрацювання правил",
};

const AUTOMATION_HISTORY = { ru, es, pt, de, fr, it, pl, tr, uk };
export default AUTOMATION_HISTORY;
